<template lang="pug">
  footer
    .inner
      p What is a site without a footer
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style lang="scss" scoped>
footer {
  flex-shrink: 0;
  display: block;
  width: 100%;
  background: rgb(26, 26, 26);
  color: white;

  .inner {
    display: flex;
    flex-direction: row;
    padding: 10px;
  }
}
</style>
